/**
 * Deja SKUs numéricos (o “casi solo dígitos”) con punto decimal para JSON/API,
 * sin tocar SKUs que mezclan letras (ej. "ABC-12").
 */
export function normalizeSkuFieldForApi(value) {
    if (value == null || value === '') return '';
    if (typeof value === 'number' && Number.isFinite(value)) {
        return String(value);
    }

    const s = String(value).trim();
    if (!s) return '';

    if (/[a-zA-Z]/.test(s)) {
        return s;
    }

    const parts = s.replace(/\s/g, '');
    const lastComma = parts.lastIndexOf(',');
    const lastDot = parts.lastIndexOf('.');

    if (lastComma > lastDot) {
        return parts.replace(/\./g, '').replace(',', '.');
    }
    if (lastDot > lastComma) {
        return parts.replace(/,/g, '');
    }
    if (lastComma !== -1 && lastDot === -1) {
        const after = parts.slice(lastComma + 1);
        if (after.length <= 2 && /^\d+$/.test(after)) {
            return `${parts.slice(0, lastComma).replace(/,/g, '')}.${after}`;
        }
        return parts.replace(/,/g, '');
    }
    return parts;
}
